<template>
  <div class="jingpin-box">
    <div v-if="list && list.length > 0" class="home-three-title">
      <div class="text">
        <img class="item-img" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/homeThree/live.png">
        <slot>最近直播</slot>
      </div>
      <span class="more" @click="zhibokes">查看更多&nbsp;></span>
    </div>
    <!-- 最近直播  内容 -->
    <div v-if="list && list.length > 0" class="jingpin">
      <div v-for="(item, index) in list" :key="index" class="item" @click="godetail(item)">
        <div class="time-tips">
          <div class="iconfont icon-a-Group19" />
          <div class="text">
            {{ item.startTime | format("MM月dd日 HH:mm") }} 开播
          </div>
          <div class="line" />
        </div>
        <div class="item-content">
          <!-- 活动详情 -->
          <div class="tips">人气值 {{ item.clicks ? item.clicks : 0 }}</div>
          <img class="item-img" :src="item.img">
          <div class="detail">
            <div class="detail-title twoEllipsis">{{ item.title }}</div>
            <!-- 价格 -->
            <div class="tea-box">
              <span class="ter">讲师：{{ item.terName }}</span>
              <img class="videoBut" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/homeThree/videoBut.png">
            </div>
          </div>
        </div>
      </div>
    </div>
 
 
  </div>
</template>
<script>
import '@/assets/css/common.css'
 
import Vue from 'vue'
import { getInfo } from '@/api/cookies'
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {},
  data() {
    return {
      userInfo: null,
      list: [],
      ifHave: false,
      liveId: null,
      ifHave: false,
      liveshowName: '',
      live: null,
      lookDeatil: null,
      showLookDetail: false
    }
  },
  created() {
    this.userInfo = getInfo()
    homeClient.getLiveshowplaybackByTypes({pageSize:5, pageNum:1}).then((res) => {
      this.list = res.data.rows
    })
  },
  methods: {
    zhibokes() {
      this.$router.push({ name: '直播课' })
    },
    godetail(item) {
      if (!this.userInfo) {
        Vue.prototype.goLoginView(true)
        return
      }
      this.liveId = item.liveId
      
    }
  }
}
</script>
<style lang="less" scoped>
.jingpin {
    width: 1222px;
  margin: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;

  &:last-child {}

  .item {
    opacity: 1;
    margin-right: 18px;
    overflow: hidden;

    &:last-child {
      margin-right: 0px;

      .time-tips {
        .line {
          display: none;
        }
      }
    }

    .time-tips {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 22px;

      .iconfont {
        font-size: 16px;
        color: #ff5e51;
        margin-right: 9px;
      }

      .text {
        flex-shrink: 0;
        font-size: 16px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }

      .line {
        width: 29px;
        height: 2px;
        background: #ff5e51;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        margin-left: 24px;
      }
    }

    .item-content {
      background: #ffffff;
      position: relative;
      width: 224px;
      // height: 278px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;

      .tips {
        position: absolute;
        height: 26px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 4px 4px 4px 4px;
        padding: 0px 8px;
        top: 12px;
        left: 12px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 26px;
      }

      .item-img {
        width: 100%;
        height: 126px;
        object-fit: cover;
        border-radius: 8px 8px 0px 0px;
        opacity: 1;
        object-fit: cover;
      }

      .detail {
        background: #ffffff;
        padding: 12px;

        .detail-title {
          height: 48px;
          font-size: 14px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
        }

        .tea-box {
          margin-top: 16px;
          height: 56px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #eeeeee;

          .videoBut {
            width: 40px;
            height: 40px;
            flex-shrink: 0;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.home-three-title {
  padding: 0px 0px 36px;
  width: 1220px;
}

.detail-ter {
  .ter-img {
    width: 24px;
    height: 24px;
  }

  .ter {
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 12px;
  }
}

.keep-learn {
  position: absolute;
  bottom: 16px;
  width: 192px;
  height: 30px;
  background: #ff5e51;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
}

.jingpin-box {
  padding-top: 30px;
}

.lookBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .ifLook {
    width: 500px;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #ccc;

    .contents {
      width: 380px;
      margin: 20px auto;

      &>span {
        color: red;
      }
    }

    .button {
      width: 120px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      border-radius: 10px;
      border: 1px solid #ccc;
      cursor: pointer;
    }
  }
}
</style>
  }
}
</style>
